import React from 'react';
import {Heading, HStack, Modal, Spinner} from 'native-base';
import {message} from './../../../utils/messages';

interface Props {
  show: boolean;
  title?: string;
}

const getDefaultMessage = () => message('spinner-modal-default-message');

const SpinnerModal = (props: Props) => {
  const {show, title} = props;
  return (
    <Modal isOpen={show}>
      <HStack space={2} justifyContent="center">
        <Spinner
          color="white"
          size="lg"
          accessibilityLabel={title ?? getDefaultMessage()}
        />
        <Heading color="white" fontSize="xl">
          {title ?? getDefaultMessage()}
        </Heading>
      </HStack>
    </Modal>
  );
};

export default SpinnerModal;
